package com.zq.my_official_website

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import myofficialwebsite_master.composeapp.generated.resources.Res
import myofficialwebsite_master.composeapp.generated.resources.home_banner
import myofficialwebsite_master.composeapp.generated.resources.home_card_focus
import myofficialwebsite_master.composeapp.generated.resources.home_card_qualification
import myofficialwebsite_master.composeapp.generated.resources.home_card_service
import myofficialwebsite_master.composeapp.generated.resources.home_logo
import myofficialwebsite_master.composeapp.generated.resources.home_tab_attendance
import myofficialwebsite_master.composeapp.generated.resources.home_tab_bi
import myofficialwebsite_master.composeapp.generated.resources.home_tab_employee
import myofficialwebsite_master.composeapp.generated.resources.home_tab_org
import myofficialwebsite_master.composeapp.generated.resources.home_tab_performance
import myofficialwebsite_master.composeapp.generated.resources.home_tab_recruit
import myofficialwebsite_master.composeapp.generated.resources.home_tab_salary
import myofficialwebsite_master.composeapp.generated.resources.home_tab_shared
import myofficialwebsite_master.composeapp.generated.resources.home_tab_talent
import myofficialwebsite_master.composeapp.generated.resources.home_tab_training
import myofficialwebsite_master.composeapp.generated.resources.home_service_ci
import myofficialwebsite_master.composeapp.generated.resources.home_service_custom
import myofficialwebsite_master.composeapp.generated.resources.home_service_data
import myofficialwebsite_master.composeapp.generated.resources.home_service_fast
import myofficialwebsite_master.composeapp.generated.resources.home_partners
import myofficialwebsite_master.composeapp.generated.resources.footer_logo
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun HomePage(
    modifier: Modifier = Modifier,
    currentPage: SitePage,
    onNavigate: (SitePage) -> Unit,
) {
    val scroll = rememberScrollState()

    Surface(modifier = modifier) {
        BoxWithConstraints(
            modifier = Modifier.fillMaxSize()
        ) {
            val isCompact = maxWidth < 900.dp
            val pageBg = Color(0xFFF7F8FB)
            val selectedTopNav = remember(currentPage) { currentPage.toTopNavIndex() }

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .verticalScroll(scroll)
                    .background(pageBg)
            ) {
                TopNav(
                    isCompact = isCompact,
                    selectedIndex = selectedTopNav,
                    onSelect = { onNavigate(sitePageFromTopNavIndex(it)) },
                )
                HeroBanner(isCompact = isCompact)

                WhyChooseSection(isCompact = isCompact)

                SectionTitle("数字化产品", topPadding = 56.dp)
                DigitalProductsTabs(isCompact = isCompact)

                EmpowermentBanner(isCompact = isCompact)

                SectionTitle("深度契合业务的定制服务", topPadding = 56.dp)
                CustomServices(isCompact = isCompact)

                SectionTitle("合作伙伴", topPadding = 56.dp)
                PartnersSection(isCompact = isCompact)

                Spacer(Modifier.height(64.dp))
                Footer(isCompact = isCompact)
            }
        }
    }
}

@Composable
private fun WhyChooseSection(isCompact: Boolean) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.White)
            .padding(bottom = 40.dp)
    ) {
        SectionTitle("为什么选择我们", topPadding = 44.dp)
        WhyChooseUs(isCompact = isCompact)
    }
}

@Composable
internal fun TopNav(
    isCompact: Boolean,
    selectedIndex: Int,
    onSelect: (Int) -> Unit,
) {
    val bg = Color.White
    val fg = Color(0xFF111827)
    val items = remember {
        listOf("首页", "产品", "方案", "合作伙伴", "关于我们")
    }
    var menuExpanded by remember { mutableStateOf(false) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(bg)
            .padding(horizontal = 20.dp, vertical = if (isCompact) 14.dp else 18.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            painter = painterResource(Res.drawable.home_logo),
            contentDescription = "logo",
            modifier = Modifier.height(if (isCompact) 54.dp else 72.dp),
            contentScale = ContentScale.Fit
        )

        Spacer(Modifier.weight(1f))

        if (!isCompact) {
            items.forEachIndexed { index, title ->
                NavItem(
                    text = title,
                    selected = index == selectedIndex,
                    fg = fg,
                    onClick = { onSelect(index) },
                    modifier = Modifier.padding(horizontal = 6.dp)
                )
            }
        } else {
            Box {
                AppText(
                    "菜单",
                    color = fg,
                    fontSize = 14.sp,
                  
                    fontWeight = FontWeight.Medium,
                    modifier = Modifier
                        .clip(RoundedCornerShape(10.dp))
                        .border(1.dp, Color(0xFFE7E9EE), RoundedCornerShape(10.dp))
                        .clickable { menuExpanded = true }
                        .padding(horizontal = 12.dp, vertical = 10.dp)
                )
                DropdownMenu(
                    expanded = menuExpanded,
                    onDismissRequest = { menuExpanded = false },
                ) {
                    items.forEachIndexed { index, title ->
                        DropdownMenuItem(
                            text = { AppText(title) },
                            onClick = {
                                onSelect(index)
                                menuExpanded = false
                            }
                        )
                    }
                }
            }
        }
    }

    HorizontalDivider(color = Color(0xFFEDEFF4))
}

@Composable
internal fun NavItem(
    text: String,
    selected: Boolean,
    fg: Color,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    AppText(
        text = text,
        color = if (selected) Color(0xFF0865FF) else fg,
        fontSize = 14.sp,
        fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Medium,
        modifier = modifier
            .clip(RoundedCornerShape(10.dp))
            .background(if (selected) Color(0x140865FF) else Color.Transparent)
            .clickable(onClick = onClick)
            .padding(horizontal = 18.dp, vertical = 10.dp)
    )
}

@Composable
private fun HeroBanner(isCompact: Boolean) {
    val height = if (isCompact) 360.dp else 520.dp
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(height)
            .drawWithContent {
                drawContent()
                drawRect(
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            Color(0x99000000),
                            Color(0x33000000),
                            Color(0xAA000000),
                        )
                    )
                )
            }
    ) {
        ResponsiveImage(
            res = Res.drawable.home_banner,
            contentDescription = "banner",
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )

        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = 20.dp),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            AppText(
                "助力国家迈向智能化未来！",
                color = Color.White,
                fontSize = if (isCompact) 18.sp else 22.sp,
                fontWeight = FontWeight.SemiBold,
                textAlign = TextAlign.Center
            )
            Spacer(Modifier.height(10.dp))
            AppText(
                "智启万物",
                color = Color.White,
                fontSize = if (isCompact) 42.sp else 64.sp,
                fontWeight = FontWeight.Bold,
                letterSpacing = 2.sp,
                textAlign = TextAlign.Center
            )
        }
    }
}

@Composable
internal fun SectionTitle(text: String, topPadding: Dp) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = topPadding, bottom = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        AppText(
            text = text,
            color = Color(0xFF111827),
            fontSize = 34.sp,
            fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Center
        )
        Spacer(Modifier.height(10.dp))
        Box(
            modifier = Modifier
                .width(80.dp)
                .height(3.dp)
                .background(Color(0xFF0865FF), RoundedCornerShape(99.dp))
        )
    }
}

@Composable
private fun WhyChooseUs(isCompact: Boolean) {
    val containerPadding = if (isCompact) 16.dp else 24.dp
    val maxContentWidth = 1100.dp

    Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
        if (!isCompact) {
            Row(
                modifier = Modifier
                    .width(maxContentWidth)
                    .padding(horizontal = containerPadding),
                horizontalArrangement = Arrangement.spacedBy(20.dp)
            ) {
                WhyCard(
                    icon = Res.drawable.home_card_qualification,
                    title = "资质权威",
                    desc = "提供一体化智能家居硬件与技术支持，打造智慧生活体验",
                    modifier = Modifier.weight(1f),
                )
                WhyCard(
                    icon = Res.drawable.home_card_service,
                    title = "服务客户",
                    desc = "以鸿蒙为基础，为企业提供设备互联互通的技术支持。",
                    modifier = Modifier.weight(1f),
                )
                WhyCard(
                    icon = Res.drawable.home_card_focus,
                    title = "专注极致",
                    desc = "前沿科技赋能，智慧驱动管理，百余功能集成，助力国家迈向智能化未来！",
                    modifier = Modifier.weight(1f),
                )
            }
        } else {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = containerPadding),
                verticalArrangement = Arrangement.spacedBy(14.dp)
            ) {
                WhyCard(
                    icon = Res.drawable.home_card_qualification,
                    title = "资质权威",
                    desc = "提供一体化智能家居硬件与技术支持，打造智慧生活体验",
                )
                WhyCard(
                    icon = Res.drawable.home_card_service,
                    title = "服务客户",
                    desc = "以鸿蒙为基础，为企业提供设备互联互通的技术支持。",
                )
                WhyCard(
                    icon = Res.drawable.home_card_focus,
                    title = "专注极致",
                    desc = "前沿科技赋能，智慧驱动管理，百余功能集成，助力国家迈向智能化未来！",
                )
            }
        }
    }
}

@Composable
private fun WhyCard(
    icon: DrawableResource,
    title: String,
    desc: String,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier
            .clip(RoundedCornerShape(18.dp))
            .border(1.dp, Color(0xFFE7E9EE), RoundedCornerShape(18.dp))
            .background(Color.White)
            .padding(horizontal = 2.dp, vertical = 2.dp)
            .padding(horizontal = 18.dp, vertical = 18.dp)
    ) {
        Image(
            painter = painterResource(icon),
            contentDescription = title,
            modifier = Modifier.size(44.dp),
            contentScale = ContentScale.Fit
        )
        Spacer(Modifier.height(12.dp))
        AppText(
            title,
            fontSize = 18.sp,
            fontWeight = FontWeight.Bold,
            color = Color(0xFF111827),
        )
        Spacer(Modifier.height(8.dp))
        AppText(
            desc,
            fontSize = 14.sp,
            color = Color(0xFF4B5563),
            lineHeight = 20.sp
        )
    }
}

private data class ProductTab(
    val title: String,
    val icon: DrawableResource,
    val description: String,
)

@Composable
private fun DigitalProductsTabs(isCompact: Boolean) {
    val tabs = remember {
        listOf(
            ProductTab(
                title = "组织",
                icon = Res.drawable.home_tab_org,
                description = "可视化多维组织架构管理，呈现不同维度组织脉络，满足组织多元管理需求，组织层级、组织负责人、组织员工数据层层穿透；组织架构时间切片，清晰回溯组织历史信息，辅助组织诊断，帮助企业管理者实时动态掌握组织全貌，优化组织决策，合理规划组织未来。"
            ),
            ProductTab(
                title = "员工",
                icon = Res.drawable.home_tab_employee,
                description = "员工“入离调转”全周期管理，形成员工360°数字档案，涵盖基本信息、任职轨迹、项目经历、业绩表现等全职业周期数据，基于管理者、决策者等不同角色需求，多视角个性化呈现员工信息，同步实现员工全局管控与规范化管理，为企业构建智慧协同的员工管理平台。"
            ),
            ProductTab(
                title = "薪资",
                icon = Res.drawable.home_tab_salary,
                description = "薪税福利统筹管理，支持新个税“累计预扣法”计算规则，灵活的薪资规则引擎，向导式智能薪资核算，高效支撑企业多样性薪酬方案落地，让HR轻松应对任意复杂薪资核算场景。支持一键输出薪资报表，满足企业按项目、按行政等各个维度汇报的需求。"
            ),
            ProductTab(
                title = "考勤",
                icon = Res.drawable.home_tab_attendance,
                description = "灵活的智能考勤管理，可满足企业复杂的个性化考勤、加班、调休规则需求，实现部门、岗位及人员的考勤差异化管理，支持跨区域、多终端考勤数据实时统计，帮助企业轻松搞定涵盖考勤、工时、排班、假期、调班、劳动力智能分析在内的全方位考勤管理。"
            ),
            ProductTab(
                title = "绩效",
                icon = Res.drawable.home_tab_performance,
                description = "系统预置丰富的绩效考核模板库，结合敏捷的绩效规则引擎，灵活适配企业各种绩效管理场景，高效落地KPI、360°、MBO、BSC等主流绩效考核方式，帮助企业建立绩效考核PDCA闭环管理体系，辅助人才管理决策优化，自上而下全面提升战略目标完成效率。"
            ),
            ProductTab(
                title = "招聘",
                icon = Res.drawable.home_tab_recruit,
                description = "招聘过程全流程跟踪，用自动化智能化代替低效沟通，支持岗位一键发布，简历智能解析去重，结合以岗位为核心的人才测评工具，科学匹配关键人才，全面提升招聘效率，一站式解决企业招聘管理难题，告别人才识别困难、招聘重复性工作量大的窘境。"
            ),
            ProductTab(
                title = "培训",
                icon = Res.drawable.home_tab_training,
                description = "实现培训计划、课程安排、导师分配、考试测评、效果分析的在线一体化管理，同时也支持企业一对一导师培训制，完善新人成长与人才培养机制，帮助企业推动学习型组织建设，可评估培训效果，打造员工随身携带的企业移动学习平台。"
            ),
            ProductTab(
                title = "人才发展",
                icon = Res.drawable.home_tab_talent,
                description = "基于人才画像、人才盘点、继任者管理，搭建企业人才资源池，帮助企业高效选拔合适人才，实现人岗匹配，打造企业内部人才成长机制，实现多样化人才发展计划，科学辅助企业人才管理智慧决策，助力企业达成组织业务目标与人才战略的匹配。"
            ),
            ProductTab(
                title = "智能报表",
                icon = Res.drawable.home_tab_bi,
                description = "预置了各个行业的常用报表模板，对接了云报表平台，并搭载了智能BI报表引擎，支持企业自助图形化建模分析，帮助企业建立完整健全的数据资产管理生态，实现数据多维动态分析与报表智能钻取，洞察组织、人、事数据全局。"
            ),
            ProductTab(
                title = "共享服务",
                icon = Res.drawable.home_tab_shared,
                description = "聚合企业内部人力资源事务性工作，将薪酬福利发放与查询、社会保险管理与查询、人事档案信息服务、劳动合同签订服务、培训服务、人才发展服务、投诉建议处理、咨询与专家服务集中于共享中心，搭建员工自助业务办理和沟通服务的平台，全面提升HR业务效率，提高员工满意度。"
            ),
        )
    }

    var selected by remember { mutableIntStateOf(0) }
    val tabScroll = rememberScrollState()

    val maxContentWidth = 1100.dp
    val containerPadding = if (isCompact) 16.dp else 24.dp

    Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
        Column(
            modifier = Modifier
                .width(maxContentWidth)
                .padding(horizontal = containerPadding)
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .horizontalScroll(tabScroll),
                horizontalArrangement = Arrangement.spacedBy(10.dp)
            ) {
                tabs.forEachIndexed { index, tab ->
                    ProductTabChip(
                        tab = tab,
                        selected = index == selected,
                        onClick = { selected = index }
                    )
                }
            }

            Spacer(Modifier.height(18.dp))

            val active = tabs[selected]
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(18.dp))
                    .border(1.dp, Color(0xFFE7E9EE), RoundedCornerShape(18.dp))
                    .background(Color(0xFFFAFBFF))
                    .padding(18.dp)
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Image(
                        painter = painterResource(active.icon),
                        contentDescription = active.title,
                        modifier = Modifier.size(44.dp),
                        contentScale = ContentScale.Fit
                    )
                    Spacer(Modifier.width(12.dp))
                    AppText(
                        active.title,
                        fontSize = 22.sp,
                        fontWeight = FontWeight.Bold,
                        color = Color(0xFF0865FF)
                    )
                }
                Spacer(Modifier.height(12.dp))
                AppText(
                    active.description,
                    fontSize = 14.sp,
                    color = Color(0xFF374151),
                    lineHeight = 22.sp
                )
            }
        }
    }
}

@Composable
private fun EmpowermentBanner(isCompact: Boolean) {
    val maxContentWidth = 1100.dp
    val containerPadding = if (isCompact) 16.dp else 24.dp

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 56.dp)
            .background(
                brush = Brush.linearGradient(
                    colors = listOf(Color(0xFF0D1B3D), Color(0xFF0B0F1D))
                )
            )
            .padding(vertical = if (isCompact) 34.dp else 44.dp),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .width(maxContentWidth)
                .padding(horizontal = containerPadding),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            AppText(
                "全员参与 为角色赋能",
                color = Color.White,
                fontSize = 34.sp,
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.Center
            )
            Spacer(Modifier.height(if (isCompact) 18.dp else 22.dp))

            val items = listOf(
                RoleItem("01", "高管", "智能决策", "SENIOR EXECUTIVE"),
                RoleItem("02", "HR", "业务增效", "HUMAN RESOURCES"),
                RoleItem("03", "员工", "成长激活", "STAFF MEMBER"),
                RoleItem("04", "高管", "智能决策", "MANAGER"),
            )

            if (!isCompact) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    items.forEachIndexed { idx, item ->
                        RoleCell(item, showDivider = idx != items.lastIndex)
                    }
                }
            } else {
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(14.dp)
                ) {
                    items.forEach { item ->
                        RoleCellCompact(item)
                    }
                }
            }
        }
    }
}

private data class RoleItem(
    val number: String,
    val title: String,
    val subtitle: String,
    val english: String,
)

@Composable
private fun RoleCell(item: RoleItem, showDivider: Boolean) {
    Row(
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column {
            AppText(
                item.number,
                color = Color(0xFF91BAFF),
                fontSize = 38.sp,
                fontWeight = FontWeight.SemiBold
            )
        }
        Spacer(Modifier.width(14.dp))
        Column {
            Row(verticalAlignment = Alignment.CenterVertically) {
                AppText(
                    item.title,
                    color = Color(0xFF0865FF),
                    fontSize = 22.sp,
                    fontWeight = FontWeight.Bold
                )
                Spacer(Modifier.width(14.dp))
                AppText(
                    item.subtitle,
                    color = Color(0xFF0865FF),
                    fontSize = 22.sp,
                    fontWeight = FontWeight.Medium
                )
            }
            Spacer(Modifier.height(6.dp))
            AppText(
                item.english,
                color = Color(0xFFAAAAAA),
                fontSize = 14.sp,
                letterSpacing = 2.sp
            )
        }

        if (showDivider) {
            Spacer(Modifier.width(22.dp))
            Box(
                modifier = Modifier
                    .height(78.dp)
                    .width(1.dp)
                    .background(Color(0xFF2B3558))
            )
            Spacer(Modifier.width(22.dp))
        }
    }
}

@Composable
private fun RoleCellCompact(item: RoleItem) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(16.dp))
            .border(1.dp, Color(0xFF27304D), RoundedCornerShape(16.dp))
            .background(Color(0x140865FF))
            .padding(14.dp)
    ) {
        AppText(
            item.number,
            color = Color(0xFF91BAFF),
            fontSize = 28.sp,
            fontWeight = FontWeight.SemiBold
        )
        Spacer(Modifier.height(6.dp))
        Row(verticalAlignment = Alignment.CenterVertically) {
            AppText(
                item.title,
                color = Color(0xFFBFD7FF),
                fontSize = 18.sp,
                fontWeight = FontWeight.Bold
            )
            Spacer(Modifier.width(12.dp))
            AppText(
                item.subtitle,
                color = Color(0xFFBFD7FF),
                fontSize = 18.sp,
                fontWeight = FontWeight.Medium
            )
        }
        Spacer(Modifier.height(6.dp))
        AppText(
            item.english,
            color = Color(0xFFAAAAAA),
            fontSize = 13.sp,
            letterSpacing = 1.5.sp
        )
    }
}

@Composable
private fun CustomServices(isCompact: Boolean) {
    val maxContentWidth = 1100.dp
    val containerPadding = if (isCompact) 16.dp else 24.dp

    val cards = listOf(
        ServiceCard(
            icon = Res.drawable.home_service_ci,
            title = "持续集成",
            desc = "RedPaaS低代码开发平台，围绕集成扩展构建了包含RedGateway、OpenAPI、RedAPI低代码开发、RedFllow、FastDev等一系列技术支撑体系，沉淀了完整的集成解决方案，可低成本高效高质量地完成异构系统集成对接。"
        ),
        ServiceCard(
            icon = Res.drawable.home_service_custom,
            title = "深度定制",
            desc = "RedPaaS低代码开发平台，将权限、规则、表单、流程、数据和HR业务进行引擎化、组件化地封装，大大降低开发和部署难度，支持人力资源业务的深度个性化定制，业务专家也可参与应用开发。"
        ),
        ServiceCard(
            icon = Res.drawable.home_service_data,
            title = "数据贯通",
            desc = "RedPaaS低代码开发平台，提供将组织异构数据、业务异构数据、内外部系统异构数据同步和贯通的整体解决方案，为企业打通以“人”为核心的所有数据环节，形成统一标准的人力资源主数据管理，并提供数据资产管理、开发、建模的能力。"
        ),
        ServiceCard(
            icon = Res.drawable.home_service_fast,
            title = "快速开发",
            desc = "RedPaaS低代码开发平台，将可视化和自动化贯穿应用开发的全生命周期管理，解放开发过程中繁冗、重复的编码工作，增强应用稳定性，比传统定制开发提高80%以上效率。"
        ),
    )

    Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
        Column(
            modifier = Modifier
                .width(maxContentWidth)
                .padding(horizontal = containerPadding),
            verticalArrangement = Arrangement.spacedBy(14.dp)
        ) {
            if (!isCompact) {
                Row(horizontalArrangement = Arrangement.spacedBy(18.dp)) {
                    ServiceCardUi(cards[0], Modifier.weight(1f))
                    ServiceCardUi(cards[1], Modifier.weight(1f))
                }
                Row(horizontalArrangement = Arrangement.spacedBy(18.dp)) {
                    ServiceCardUi(cards[2], Modifier.weight(1f))
                    ServiceCardUi(cards[3], Modifier.weight(1f))
                }
            } else {
                cards.forEach { ServiceCardUi(it) }
            }
        }
    }
}

private data class ServiceCard(
    val icon: DrawableResource,
    val title: String,
    val desc: String,
)

@Composable
private fun ServiceCardUi(
    card: ServiceCard,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier
            .clip(RoundedCornerShape(18.dp))
            .border(1.dp, Color(0xFFE7E9EE), RoundedCornerShape(18.dp))
            .background(Color.White)
            .padding(horizontal = 18.dp, vertical = 18.dp)
    ) {
        Image(
            painter = painterResource(card.icon),
            contentDescription = card.title,
            modifier = Modifier.size(56.dp),
            contentScale = ContentScale.Fit
        )
        Spacer(Modifier.width(14.dp))
        Column {
            AppText(
                card.title,
                fontSize = 18.sp,
                fontWeight = FontWeight.Bold,
                color = Color(0xFF111827),
                letterSpacing = 1.2.sp
            )
            Spacer(Modifier.height(8.dp))
            AppText(
                card.desc,
                fontSize = 14.sp,
                color = Color(0xFF555555),
                lineHeight = 22.sp
            )
        }
    }
}

@Composable
private fun PartnersSection(isCompact: Boolean) {
    val maxContentWidth = 1100.dp
    val containerPadding = if (isCompact) 16.dp else 24.dp

    Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
        Column(
            modifier = Modifier
                .width(maxContentWidth)
                .padding(horizontal = containerPadding)
        ) {
            val maxH = if (isCompact) 240.dp else 420.dp
            ResponsiveImage(
                res = Res.drawable.home_partners,
                contentDescription = "合作伙伴",
                modifier = Modifier
                    .fillMaxWidth()
                    .heightIn(min = 160.dp, max = maxH)
                    .clip(RoundedCornerShape(18.dp))
                    .border(1.dp, Color(0xFFE7E9EE), RoundedCornerShape(18.dp)),
                contentScale = ContentScale.Crop
            )
        }
    }
}

@Composable
private fun ProductTabChip(
    tab: ProductTab,
    selected: Boolean,
    onClick: () -> Unit,
) {
    val shape = RoundedCornerShape(12.dp)
    val bg = if (selected) Color(0xFF0865FF) else Color.White
    val border = if (selected) Color(0xFF0865FF) else Color(0xFFE7E9EE)
    val textColor = if (selected) Color.White else Color(0xFF111827)

    Row(
        modifier = Modifier
            .clip(shape)
            .border(1.dp, border, shape)
            .background(bg)
            .clickable(onClick = onClick)
            .padding(horizontal = 12.dp, vertical = 10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            painter = painterResource(tab.icon),
            contentDescription = tab.title,
            modifier = Modifier.size(22.dp),
            contentScale = ContentScale.Fit
        )
        Spacer(Modifier.width(8.dp))
        AppText(
            tab.title,
            color = textColor,
            fontSize = 14.sp,
            fontWeight = FontWeight.SemiBold
        )
    }
}

@Composable
internal fun Footer(isCompact: Boolean) {
    val uriHandler = LocalUriHandler.current

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color(0xFF13131B))
            .padding(vertical = if (isCompact) 22.dp else 28.dp, horizontal = 20.dp),
    ) {
        val maxContentWidth = 1100.dp
        Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
            if (!isCompact) {
                Row(
                    modifier = Modifier.width(maxContentWidth),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.Top
                ) {
                    Column(modifier = Modifier.width(260.dp)) {
                        ResponsiveImage(
                            res = Res.drawable.footer_logo,
                            contentDescription = "logo",
                            modifier = Modifier.height(56.dp),
                            contentScale = ContentScale.Fit
                        )
                        Spacer(Modifier.height(12.dp))
                        Box(
                            modifier = Modifier
                                .width(210.dp)
                                .height(1.dp)
                                .background(Color(0xFF2B2B3A))
                        )
                    }

                    Column(modifier = Modifier.width(520.dp)) {
                        AppText(
                            "联系我们",
                            color = Color(0xFFDDDDDD),
                            fontSize = 16.sp,
                            fontWeight = FontWeight.SemiBold
                        )
                        Spacer(Modifier.height(14.dp))

                        FooterInfoRow(
                            isCompact = false,
                            label = "地址：",
                            value = "深圳市南山区粤海街道高新区社区高新南九道59号北科大厦4楼435B"
                        )
                        Spacer(Modifier.height(10.dp))
                        FooterInfoRow(
                            isCompact = false,
                            label = "电话：",
                            value = "18320985107"
                        )
                    }

                    Spacer(Modifier.width(120.dp))
                }
            } else {
                Column(
                    modifier = Modifier
                        .widthIn(max = maxContentWidth)
                        .fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    ResponsiveImage(
                        res = Res.drawable.footer_logo,
                        contentDescription = "logo",
                        modifier = Modifier.height(52.dp),
                        contentScale = ContentScale.Fit
                    )
                    Spacer(Modifier.height(12.dp))
                    Box(
                        modifier = Modifier
                            .width(210.dp)
                            .height(1.dp)
                            .background(Color(0xFF2B2B3A))
                    )
                    Spacer(Modifier.height(16.dp))

                    AppText(
                        "联系我们",
                        color = Color(0xFFDDDDDD),
                        fontSize = 16.sp,
                        fontWeight = FontWeight.SemiBold,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth()
                    )
                    Spacer(Modifier.height(14.dp))

                    FooterInfoRow(
                        isCompact = true,
                        label = "地址",
                        value = "深圳市南山区粤海街道高新区社区高新南九道59号北科大厦4楼435B"
                    )
                    Spacer(Modifier.height(12.dp))
                    FooterInfoRow(
                        isCompact = true,
                        label = "电话",
                        value = "18320985107"
                    )
                }
            }
        }

        Spacer(Modifier.height(if (isCompact) 16.dp else 18.dp))

        Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
            Column(
                modifier = Modifier
                    .widthIn(max = maxContentWidth)
                    .fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                if (isCompact) {
                    AppText(
                        "版权所有@智启万物",
                        color = Color(0xFFDDDDDD),
                        fontSize = 13.sp,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    Spacer(Modifier.height(6.dp))
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.Center,
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        AppText(
                            "网站备案：",
                            color = Color(0xFFDDDDDD),
                            fontSize = 13.sp,
                        )
                        AppText(
                            "粤ICP备2025372870号-1",
                            color = Color(0xFF8AB4FF),
                            fontSize = 13.sp,
                            textDecoration = TextDecoration.Underline,
                            modifier = Modifier.clickable {
                                uriHandler.openUri("https://beian.miit.gov.cn/")
                            },
                        )
                    }
                } else {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.Center,
                        modifier = Modifier.fillMaxWidth(),
                    ) {
                        AppText(
                            "版权所有@智启万物",
                            color = Color(0xFFDDDDDD),
                            fontSize = 13.sp,
                        )
                        Spacer(Modifier.width(12.dp))
                        AppText(
                            "网站备案：",
                            color = Color(0xFFDDDDDD),
                            fontSize = 13.sp,
                        )
                        AppText(
                            "粤ICP备2025372870号-1",
                            color = Color(0xFF8AB4FF),
                            fontSize = 13.sp,
                            textDecoration = TextDecoration.Underline,
                            modifier = Modifier.clickable {
                                uriHandler.openUri("https://beian.miit.gov.cn/")
                            },
                        )
                    }
                }

                Spacer(Modifier.height(10.dp))
                AppText(
                    "本网站支持 IPv6",
                    color = Color(0xFF9CA3AF),
                    fontSize = 14.sp,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
}

@Composable
private fun FooterInfoRow(isCompact: Boolean, label: String, value: String) {
    if (!isCompact) {
        Row {
            AppText(
                label,
                color = Color(0xFFDDDDDD),
                fontSize = 14.sp,
            )
            AppText(
                value,
                color = Color(0xFFDDDDDD),
                fontSize = 14.sp,
                lineHeight = 20.sp
            )
        }
    } else {
        Column(modifier = Modifier.fillMaxWidth()) {
            AppText(
                "$label：",
                color = Color(0xFFDDDDDD),
                fontSize = 14.sp,
                fontWeight = FontWeight.SemiBold
            )
            Spacer(Modifier.height(6.dp))
            AppText(
                value,
                color = Color(0xFFDDDDDD),
                fontSize = 14.sp,
                lineHeight = 20.sp
            )
        }
    }
}

@Composable
internal fun ResponsiveImage(
    res: DrawableResource,
    contentDescription: String?,
    modifier: Modifier = Modifier,
    contentScale: ContentScale,
) {
    // 统一处理不同端的图片缩放：避免拉伸，尽量保持清晰与比例稳定
    Image(
        painter = painterResource(res),
        contentDescription = contentDescription,
        modifier = modifier,
        contentScale = contentScale,
    )
}


